import MainHead from './MainHead.vue'

export default MainHead
